<template>
    <el-row :gutter="20">
        <el-col :span="8">
            <div class="info-col">
                <el-text class="mx-1" type="primary" size="large">{{ dashboardStore.todayUser }} / {{
                    dashboardStore.totalUser }}</el-text>
                <el-text class="mx-1">今日新增 / 总用户数</el-text>
            </div>
        </el-col>
        <el-col :span="8">
            <div class="info-col">
                <el-text class="mx-1" type="primary" size="large">{{ dashboardStore.todayDeposit }} / {{
                    dashboardStore.totalDeposit }}</el-text>
                <el-text class="mx-1">今日充值 / 总充值数</el-text>
            </div>
        </el-col>
        <el-col :span="8">
            <div class="info-col">
                <el-text class="mx-1" type="primary" size="large">{{ dashboardStore.todayCost }} / {{
                    dashboardStore.totalCost }}</el-text>
                <el-text class="mx-1">今日消费 / 总消费数</el-text>
            </div>
        </el-col>
    </el-row>
    <el-row :gutter="20">
        <el-col :span="8">
            <div class="info-col">
                <el-text class="mx-1" type="primary" size="large">{{ dashboardStore.todayDraw }} / {{
                    dashboardStore.totalDraw }}</el-text>
                <el-text class="mx-1">今日抽卡 / 总抽卡次数</el-text>
            </div>
        </el-col>
        <!-- <el-col :span="8">
            <div class="info-col">

            </div>
        </el-col>
        <el-col :span="8">
            <div class="info-col">

            </div>
        </el-col> -->
    </el-row>
</template>

<script setup>
import { onMounted } from "vue";
import { useDashboardStore } from "@/stores/dashboard";

const dashboardStore = useDashboardStore();

onMounted(async () => {
    await dashboardStore.getSummary();
});
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
}

.info-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 120px;
    border-radius: 12px;
    border: 2px solid grey;
    box-shadow: var(--el-box-shadow);
}
</style>
